import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { SpecialFieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { SpecialFieldUrlTypeMap } from 'FormsUI/constants/SpecialFieldUrls';

// @ts-expect-error types missing
import FormFieldConfigurationPanel from 'FormsUI/components/editor/form/configuration/FormFieldConfigurationPanel';
import CaptchaConfigurationPanel from 'FormsUI/components/editor/form/configuration/CaptchaConfigurationPanel';
// @ts-expect-error types missing
import LegalConsentConfigurationPanel from 'FormsUI/components/editor/form/configuration/LegalConsentConfigurationPanel';
// @ts-expect-error types missing
import RichTextConfigurationPanel from 'FormsUI/components/editor/form/configuration/RichTextConfigurationPanel';
// @ts-expect-error types missing
import ImageConfigurationPanel from 'FormsUI/components/editor/form/configuration/ImageConfigurationPanelContainer';
// @ts-expect-error types missing
import SubmitButtonConfigurationPanel from 'FormsUI/components/editor/form/configuration/SubmitButtonConfigurationPanel';
import { jsx as _jsx } from "react/jsx-runtime";
const getFieldTypeByReference = ({
  selectedFormItemReference,
  selectedFormItemType
}) => {
  return SpecialFieldUrlTypeMap[selectedFormItemReference] || selectedFormItemType;
};
const getFormFieldByType = ({
  formGuid,
  hideConfigurationPanel,
  selectedFormItemReference,
  selectedFormItemType,
  updateFieldValidation,
  updateForm,
  updateFormField,
  updateFormFieldGroup
}) => {
  const fieldTypeByReference = getFieldTypeByReference({
    selectedFormItemReference,
    selectedFormItemType
  });
  switch (fieldTypeByReference) {
    case FieldTypes.TEXT:
    case FieldTypes.CHECKBOX:
    case FieldTypes.SINGLE_CHECKBOX:
    case FieldTypes.RADIO:
    case FieldTypes.SELECT:
    case FieldTypes.DATE:
    case FieldTypes.TEXTAREA:
    case FieldTypes.NUMBER:
    case FieldTypes.FILE:
    case FieldTypes.PHONE:
    case FieldTypes.PHONE_NUMBER:
      return /*#__PURE__*/_jsx(FormFieldConfigurationPanel, {
        formFieldId: selectedFormItemReference,
        update: updateFormField,
        updateValidation: updateFieldValidation,
        hideConfigurationPanel: hideConfigurationPanel
      }, selectedFormItemReference);
    case SpecialFieldTypes.CAPTCHA:
      return /*#__PURE__*/_jsx(CaptchaConfigurationPanel, {
        hideConfigurationPanel: hideConfigurationPanel
      });
    case SpecialFieldTypes.LEGAL_CONSENT:
      return /*#__PURE__*/_jsx(LegalConsentConfigurationPanel, {
        hideConfigurationPanel: hideConfigurationPanel
      });
    case SpecialFieldTypes.RICH_TEXT:
      return /*#__PURE__*/_jsx(RichTextConfigurationPanel, {
        richTextId: selectedFormItemReference,
        update: updateFormFieldGroup,
        hideConfigurationPanel: hideConfigurationPanel
      });
    case SpecialFieldTypes.IMAGE:
      return /*#__PURE__*/_jsx(ImageConfigurationPanel, {
        richTextId: selectedFormItemReference,
        update: updateFormFieldGroup,
        hideConfigurationPanel: hideConfigurationPanel
      });
    case FieldTypes.SUBMIT:
      return /*#__PURE__*/_jsx(SubmitButtonConfigurationPanel, {
        formGuid: formGuid,
        update: updateForm,
        hideConfigurationPanel: hideConfigurationPanel
      });
    case FieldTypes.PAYMENT_RADIO:
      return /*#__PURE__*/_jsx(FormFieldConfigurationPanel, {
        formFieldId: selectedFormItemReference,
        update: updateFormField,
        updateValidation: updateFieldValidation,
        hideConfigurationPanel: hideConfigurationPanel,
        renderObjectType: false
      }, selectedFormItemReference);
    default:
      return null;
  }
};
export default getFormFieldByType;